import { useEffect, useState } from 'react';
import ProjectOther from './ProjectOther';
import { BaseUrl } from "../../helper/BaseUrl";
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import axios from "axios";

export default function ProjectDetail() {
    const handleScroll = () => {
    document
      .getElementById("project-scroll")
      .scrollIntoView({ behavior: "smooth" });
    };

    const navigate = useNavigate();
    const { slug } = useParams();
    const [data, setData] = useState([]);

    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get(`${BaseUrl}/api/project/${slug}`);
          setData(response.data.data);
          if(response.error){
            navigate("/404")
          }
        } catch (error) {
          console.error("Error fetching blog data:", error);
        }
      };
  
      fetchData();
    }, [slug]);
  
  return (
    <>
    <section className="project-banner">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <div className="proj-bannerbox">
                      <img src={`${BaseUrl}${data?.banner_image}`} className="img-responsive" alt="project"/>
                      <div>
                          <span onClick={handleScroll}>scroll</span>
                          <p>{data?.category}</p> 
                      </div>
                    </div>
                </div>
    
            </div>
        </div>
    </section>


    <section id="project-scroll">
        <div className="container">
            <div className="row">

                <div className="col-lg-6 col-md-6">
                    <div className="project-namebox wow animate__animated animate__fadeInUp" data-wow-duration="1.4s" data-wow-delay="0.2s" >
                      <h1 className='heading'>{data?.title}</h1>             
                      <div dangerouslySetInnerHTML={{__html:data?.description}}/>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    {Array.isArray(data?.images1) && data.images1.length > 0 && (
                        <div className="project-nameimage">
                            {data.images1.map((img, idx) => (
                            <img src={`${BaseUrl}${img}`} key={idx} className="img-responsive" alt="project" loading="lazy"/>
                            ))}
                        </div>
                    )}
                </div>

                <div className="col-lg-12">
                    <img src={`${BaseUrl}${data?.image2}`} className="img-responsive radius-8" loading="lazy" alt="project"/>
                </div>
    
            </div>
        </div>
    </section>


    <section className="project-single">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-5 col-md-6 col-9 col-sm-8">
                  <img src={`${BaseUrl}${data?.image3}`} className="img-responsive" loading="lazy" alt="project"/>
                  
                  <div className="wow animate__animated animate__fadeInDown" data-wow-duration=".8s" data-wow-delay="0.1s" dangerouslySetInnerHTML={{__html:data?.first_description}}/>
                </div>
            </div>
        </div>
    </section>


    <section className="project-heading project-gap">
        <div className="container">
            <div className="row align-items-center">

                <div className="col-lg-12">
                    <img src={`${BaseUrl}${data?.image4}`} loading="lazy" className="img-responsive project-gap" alt="project"/>
                </div>

                <div className="col-lg-6 col-md-6">
                    <div className="project-headbox wow animate__animated animate__fadeInLeft" data-wow-duration="1.4s" data-wow-delay="0.2s" >
                      <h2 className='heading'>{data?.second_title}</h2>

                      <div dangerouslySetInnerHTML={{__html:data?.second_description}}/>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <img src={`${BaseUrl}${data?.image5}`} loading="lazy" className="img-responsive" alt="project"/>
                </div>

            </div>
        </div>
    </section>


    <section className="project-allimage">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">

                    {Array.isArray(data?.images) && data.images.length > 0 && (
                        <div className="proj-allimage">
                            {data.images.map((img, idx) => (
                            <img src={`${BaseUrl}${img}`} key={idx} className="img-responsive project-gap" alt="project" loading="lazy"/>
                            ))}
                        </div>
                    )}


                    {/* <div className="proj-allimage">
                        <img src="/image/project-image-7.webp" loading="lazy" className="img-responsive project-gap" alt="project"/>
                        <img src="/image/project-image-8.webp" loading="lazy" className="img-responsive project-gap" alt="project"/>
                        <img src="/image/project-image-9.webp" loading="lazy" className="img-responsive project-gap" alt="project"/>
                        <img src="/image/project-image-10.webp" loading="lazy" className="img-responsive project-gap" alt="project"/>
                        <img src="/image/project-image-11.webp" loading="lazy" className="img-responsive project-gap" alt="project"/>
                    </div> */}
                </div>

            </div>
        </div>
    </section>


    <section className="project-location">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <div className="projlocat-box">
                        <div>
                            <span>Location</span>
                            <p>{data?.location}</p>
                        </div>

                        <div>
                            <span>Project Time</span>
                            <p>{data?.project_time}</p>
                        </div>

                        <div>
                            <span>Rooms</span>
                            <p>{data?.rooms}</p>
                        </div>

                        <div>
                            <span>Project Scope/Type</span>
                            <p>{data?.project_scope}</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>


    {/* <section id="project-scroll">
        <div className="container">
            <div className="row">

                <div className="col-lg-6 col-md-6">
                    <div className="project-namebox wow animate__animated animate__fadeInUp" data-wow-duration="1.4s" data-wow-delay="0.2s" >
                      <h1 className='heading'>The Regal Essence Livingspace</h1>
                      <p>Clean lines and a seamless flow define this sophisticated modular workspace. Premium finishes, intelligent layouts, and ergonomic furnishings work in harmony with a muted colour palette to create an aura of professionalism and modern allure.</p>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <div className="project-nameimage">
                      <img src="/image/project-image-1.webp" className="img-responsive" loading="lazy" alt="project"/>
                      <img src="/image/project-image-2.webp" className="img-responsive" loading="lazy" alt="project"/>
                    </div>
                </div>

                <div className="col-lg-12">
                    <img src="/image/project-image-3.webp" className="img-responsive" loading="lazy" alt="project"/>
                </div>
    
            </div>
        </div>
    </section>


    <section className="project-single">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-5 col-md-6 col-9 col-sm-8">
                  <img src="/image/project-image-4.webp" className="img-responsive" loading="lazy" alt="project"/>
                  <p className="wow animate__animated animate__fadeInDown" data-wow-duration=".8s" data-wow-delay="0.1s">The integration of wooden textures, carefully crafted details, and natural finishes brings warmth and character to every corner of the home. Each grain of wood adds depth and storytelling, creating an atmosphere that feels both timeless and welcoming.</p>
                </div>
            </div>
        </div>
    </section>


    <section className="project-heading project-gap">
        <div className="container">
            <div className="row align-items-center">

                <div className="col-lg-12">
                    <img src="/image/project-image-5.webp" loading="lazy" className="img-responsive project-gap" alt="project"/>
                </div>

                <div className="col-lg-6 col-md-6">
                    <div className="project-headbox wow animate__animated animate__fadeInLeft" data-wow-duration="1.4s" data-wow-delay="0.2s" >
                      <h2 className='heading'>Elegant Work</h2>
                      <p>This modular office strikes the perfect balance between functionality and refined design. The sleek workstation modules, paired with bespoke storage solutions, offer both efficiency and elegance, while collaborative zones are designed to encourage interaction and innovation.</p>

                      <p>Accents of brushed metal and warm wood finishes highlight the overall aesthetic, giving the workspace a distinct identity where every detail reflects a premium, contemporary approach to modern work culture.</p>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <img src="/image/project-image-6.webp" loading="lazy" className="img-responsive" alt="project"/>
                </div>

            </div>
        </div>
    </section>


    <section className="project-allimage">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <div className="proj-allimage">
                        <img src="/image/project-image-7.webp" loading="lazy" className="img-responsive project-gap" alt="project"/>
                        <img src="/image/project-image-8.webp" loading="lazy" className="img-responsive project-gap" alt="project"/>
                        <img src="/image/project-image-9.webp" loading="lazy" className="img-responsive project-gap" alt="project"/>
                        <img src="/image/project-image-10.webp" loading="lazy" className="img-responsive project-gap" alt="project"/>
                        <img src="/image/project-image-11.webp" loading="lazy" className="img-responsive project-gap" alt="project"/>
                    </div>
                </div>

            </div>
        </div>
    </section>


    <section className="project-location">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <div className="projlocat-box">
                        <div>
                        <span>Location</span>
                        <p>Gurugram</p>
                        </div>

                        <div>
                        <span>Project Time</span>
                        <p>24 Days</p>
                        </div>

                        <div>
                        <span>Rooms</span>
                        <p>4 Bedroom</p>
                        </div>

                        <div>
                        <span>Project Scope/Type</span>
                        <p>Modular Work</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section> */}

    <ProjectOther/>
    </>
  )
}
